import { SanityLargeTeaser } from '../../types/generated/graphql-types'
import { LargeTeaserProps } from '../components/blocks/LargeTeaser'
import { Breakpoints } from '../utilities/breakpoints'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'
import { sanityBasicBackgroundVideoToVideoTeaserPreviewImage } from './VideoMapper'

export const mapSanityLargeTeaserToLargeTeaserProps = ({
  catchline1,
  catchline2,
  image,
  link,
  subtitle,
  text,
  title,
  useVideo,
  video,
  videoControls,
}: SanityLargeTeaser): LargeTeaserProps => ({
  catchline1: catchline1 ?? undefined,
  catchline2: catchline2 ?? undefined,
  image: validImage(image)
    ? getImagePropsWithSources(
        image,
        {
          small: Presets.largeTeaser.small,
          medium: Presets.largeTeaser.medium,
          large: Presets.largeTeaser.large,
          extraLarge: Presets.largeTeaser.extraLarge,
        },
        Breakpoints.md,
        Breakpoints.xl,
        Breakpoints.xxl
      )
    : undefined,
  link: link ? mapSanityLinkToInternalExternalLink(link) : undefined,
  subtitle: subtitle ?? '',
  text: text ?? '',
  title: title ?? '',
  videoPreviewImage:
    useVideo && video?.image
      ? sanityBasicBackgroundVideoToVideoTeaserPreviewImage(video)
      : undefined,
  videoUrl: useVideo ? video?.url ?? '' : undefined,
  videoControls: videoControls ?? false,
})
